import { render } from "./HistoricoPedidoEmAndamentoPDF.vue?vue&type=template&id=ca04526a&scoped=true"
import script from "./HistoricoPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"
export * from "./HistoricoPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"

import "./HistoricoPedidoEmAndamentoPDF.vue?vue&type=style&index=0&id=ca04526a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca04526a"]])

export default __exports__